import { render, staticRenderFns } from "./ContactEstatePlanning.vue?vue&type=template&id=04c7646e"
import script from "./ContactEstatePlanning.vue?vue&type=script&lang=js"
export * from "./ContactEstatePlanning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports